import React from 'react';

export default function CheckoutField({ id, label, required, children, hint }) {
  return (
    <div className="checkout-field">
      <label className="checkout-field__label" htmlFor={id}>
        {label}
        {required ? <span className="checkout-field__req">*</span> : null}
      </label>
      {children}
      {hint ? <p className="checkout-field__hint">{hint}</p> : null}
    </div>
  );
}
